import Component from '@glimmer/component';
/**
 @class DownloadDropdownComponent

 */
export default class NwDeepResearchDownloadDropdownComponent extends Component {}
